import { ProductType } from "../types";

export const getProductImage = (selectedProduct: ProductType) => {
    try {
        const file = JSON.parse(selectedProduct?.imageUrl);
        return file?.url;
    } catch (e) {
        console.error("THere is no product selected or the product doesn't have image in it.");
    }
    return "";
};

export const getSalesChannelImage = (salesChannel: any, field: string = "logo"): string => {
    try {
        const imageField = field === "icon" ? "icon" : "logo";
        const imageJson = salesChannel?.[imageField];

        if (imageJson) {
            const imageObj = JSON.parse(imageJson);
            return imageObj?.url.replace('http://', 'https://') || "";
        }
    } catch (error) {
        console.error("Error retrieving the sales channel image:", error);
    }

    return "";
};
